module.exports = __webpack_public_path__ + "static/scale-model-of-caladesi-island-state-park-in-clearwater-florida-772f98392685da533b6d9ff306b20677.png";